import { createSlice } from '@reduxjs/toolkit';

// Icon imports
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import ApartmentIcon from "@mui/icons-material/Apartment";
import VillaIcon from "@mui/icons-material/Villa";
import KitchenIcon from "@mui/icons-material/Kitchen";
import BathtubIcon from "@mui/icons-material/Bathtub";
import YardIcon from "@mui/icons-material/Yard";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ConstructionIcon from "@mui/icons-material/Construction";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PeopleIcon from "@mui/icons-material/People";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ConsultationIcon from "@mui/icons-material/RecordVoiceOver";
import PlanningIcon from "@mui/icons-material/Map";
import ExecutionIcon from "@mui/icons-material/Build";
import HandoverIcon from "@mui/icons-material/AssignmentTurnedIn";

import renovation1 from "../images/renovation/renovation1.jpg";
import renovation2 from "../images/renovation/renovation2.jpg";
import Landspacp from "../images/Landspacp.jpeg";
import Lighting from "../images/Lighting.jpeg";
import RetailSpace from "../images/RetailSpace.jpeg"; 
import Kitchen from "../images/Kitchen.jpeg";
import Apertment from "../images/Apertment.jpeg";

// Initial state
const initialState = {
  hero: {
    title: "Spaces designed to reflect your lifestyle — quietly elegant, thoughtfully planned.",
    subtitle: "Transform your space with our professional design solutions. From residential to commercial, we cover all aspects of interior design.",
    backgroundImage: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80",
    badge: "20+ Design Services Available",
    // stats: [
    //   {
    //     value: "50+",
    //     label: "Design Experts",
    //     icon: <PeopleIcon />,
    //     color: "#FF6B35"
    //   },
    //   {
    //     value: "100%",
    //     label: "Satisfaction",
    //     icon: <ThumbUpIcon />,
    //     color: "#FF6B35"
    //   },
    //   {
    //     value: "24/7",
    //     label: "Support",
    //     icon: <VerifiedUserIcon />,
    //     color: "#FF6B35"
    //   }
    // ]
  },

  // Categories
  categories: [
    {
      id: 1,
      name: "Residential",
      icon: <HomeIcon />,
      description: "Home interior design services",
      color: "#FF6B35"
    },
    {
      id: 2,
      name: "Commercial",
      icon: <BusinessIcon />,
      description: "Office and business spaces",
      color: "#008C9E"
    },
    {
      id: 3,
      name: "Renovation",
      icon: <ConstructionIcon />,
      description: "Space transformation",
      color: "#1D3557"
    },
    {
      id: 4,
      name: "New Project",
      icon: <DesignServicesIcon />,
      description: "Custom design solutions",
      color: "#695424ff"
    }
  ],

  allServices: [
    {
      id: 1,
      title: "Full Home Design",
      slug: "full-home-design",
      description: "Complete interior design for your entire home, including all rooms and common areas",
      image: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <HomeIcon sx={{ color: "#FF6B35" }} />,
      category: "Residential",
      categories: ["Residential"],
      features: ["Space Planning", "Color Scheme", "Furniture Selection", "Lighting Design"],
      pricingNote: "Custom quote based on square footage",
      duration: "8-12 Weeks",
      rating: 4.9,
      tags: ["popular", "luxury"],
      isPopular: true,
      color: "#FF6B35"
    },
    {
      id: 2,
      title: "Office Design",
      slug: "office-design",
      description: "Professional workspace design that enhances productivity and collaboration",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <BusinessIcon sx={{ color: "#008C9E" }} />,
      category: "Commercial",
      categories: ["Commercial"],
      features: ["Ergonomic Design", "Collaborative Spaces", "Brand Integration", "Tech Infrastructure"],
      pricingNote: "Price per square foot",
      duration: "10-16 Weeks",
      rating: 4.8,
      tags: ["popular", "commercial"],
      isPopular: true,
      color: "#008C9E"
    },
    {
      id: 3,
      title: "Kitchen Renovation",
      slug: "kitchen-renovation",
      description: "Modern kitchen design with functionality and aesthetics in mind",
      image: Kitchen,
      icon: <KitchenIcon sx={{ color: "#1D3557" }} />,
      category: "Renovation",
      categories: ["Renovation", "Residential"],
      features: ["Cabinetry Design", "Countertop Selection", "Appliance Planning", "Lighting Layout"],
      pricingNote: "Including materials and labor",
      duration: "4-6 Weeks",
      rating: 4.9,
      tags: ["popular", "budget"],
      isPopular: true,
      color: "#1D3557"
    },
    {
      id: 4,
      title: "Bathroom Design",
      slug: "bathroom-design",
      description: "Luxurious bathroom designs that combine comfort and style",
      image: renovation2,
      icon: <BathtubIcon sx={{ color: "#008C9E" }} />,
      category: "Renovation",
      categories: ["Renovation"],
      features: ["Wet Area Planning", "Fixtures Selection", "Tile Design", "Storage Solutions"],
      pricingNote: "Basic package starts at $2,500",
      duration: "3-5 Weeks",
      rating: 4.7,
      tags: ["budget"],
      isPopular: false,
      color: "#008C9E"
    },
    {
      id: 5,
      title: "Landscape Design",
      slug: "landscape-design",
      description: "Outdoor space design that complements your interior",
      image: Landspacp,
      icon: <YardIcon sx={{ color: "#695424ff" }} />,
      category: "newProject",
      categories: ["newProject"],
      features: ["Garden Planning", "Outdoor Lighting", "Hardscape Design", "Plant Selection"],
      pricingNote: "Includes planting and materials",
      duration: "6-8 Weeks",
      rating: 4.8,
      tags: ["eco-friendly"],
      isPopular: false,
      color: "#695424ff"
    },
    {
      id: 6,
      title: "Lighting Design",
      slug: "lighting-design",
      description: "new project lighting solutions for ambiance and functionality",
      image: Lighting,
      icon: <LightbulbIcon sx={{ color: "#FF6B35" }} />,
      category: "newproject",
      categories: ["newproject"],
      features: ["Ambient Lighting", "Task Lighting", "Accent Lighting", "Smart Controls"],
      pricingNote: "Per room",
      duration: "2-3 Weeks",
      rating: 4.6,
      tags: ["budget"],
      isPopular: false,
      color: "#FF6B35"
    },
    {
      id: 7,
      title: "Apartment Design",
      slug: "apartment-design",
      description: "Space-efficient designs for apartments and condos",
      image: Apertment,
      icon: <ApartmentIcon sx={{ color: "#1D3557" }} />,
      category: "Residential",
      categories: ["Residential"],
      features: ["Space Optimization", "Multifunctional Furniture", "Storage Solutions", "Compact Design"],
      pricingNote: "Studio/1BHK starting price",
      duration: "4-8 Weeks",
      rating: 4.8,
      tags: ["budget", "popular"],
      isPopular: true,
      color: "#1D3557"
    },
    {
      id: 8,
      title: "Villa Design",
      slug: "villa-design",
      description: "Luxury design solutions for villas and large homes",
      image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      icon: <VillaIcon sx={{ color: "#695424ff" }} />,
      category: "Residential",
      categories: ["Residential"],
      features: ["Premium Materials", "Custom Furniture", "Art Curation", "Smart Home Integration"],
      pricingNote: "Starting price for 3000 sq ft",
      duration: "16-24 Weeks",
      rating: 5.0,
      tags: ["luxury"],
      isPopular: false,
      color: "#695424ff"
    },
    {
      id: 9,
      title: "Retail Space Design",
      slug: "retail-space-design",
      description: "Design that enhances customer experience and boosts sales",
      image: RetailSpace,
      icon: <DesignServicesIcon sx={{ color: "#008C9E" }} />,
      category: "Commercial",
      categories: ["Commercial"],
      features: ["Customer Flow", "Product Display", "Branding Integration", "Lighting Design"],
      pricingNote: "Per 1000 sq ft",
      duration: "8-12 Weeks",
      rating: 4.7,
      tags: ["commercial"],
      isPopular: false,
      color: "#008C9E"
    }
  ],

  popularServices: [
    {
      id: 1,
      title: "Full Home Design",
      description: "A complete end-to-end service that transforms homes with cohesive design, comfort, and elegance.",
      highlight: "End-to-End Transformation",
      icon: <HomeIcon sx={{ color: "#FF6B35", fontSize: 40 }} />,
      color: "#FF6B35"
    },
    {
      id: 2,
      title: "Kitchen Renovation",
      description: "Thoughtfully designed kitchens that balance functionality, style, and everyday convenience.",
      highlight: "Functional & Stylish Spaces",
      icon: <KitchenIcon sx={{ color: "#1D3557", fontSize: 40 }} />,
      color: "#1D3557"
    },
    {
      id: 3,
      title: "Office Design",
      description: "Modern office environments crafted to inspire productivity, comfort, and collaboration.",
      highlight: "Smart Workspace Design",
      icon: <BusinessIcon sx={{ color: "#008C9E", fontSize: 40 }} />,
      color: "#008C9E"
    }
  ],


  serviceProcess: [
    {
      id: 1,
      number: "01",
      title: "Initial Consultation",
      description: "Free design consultation to understand your needs",
      icon: <ConsultationIcon sx={{ color: "#FF6B35", fontSize: 40 }} />
    },
    {
      id: 2,
      number: "02",
      title: "Design Planning",
      description: "Detailed planning with 3D visualizations",
      icon: <PlanningIcon sx={{ color: "#FF6B35", fontSize: 40 }} />
    },
    {
      id: 3,
      number: "03",
      title: "Execution",
      description: "Professional implementation with quality materials",
      icon: <ExecutionIcon sx={{ color: "#FF6B35", fontSize: 40 }} />
    },
    {
      id: 4,
      number: "04",
      title: "Final Handover",
      description: "Complete project delivery with support",
      icon: <HandoverIcon sx={{ color: "#FF6B35", fontSize: 40 }} />
    }
  ],

  // Service Benefits
  serviceBenefits: {
    description: "We provide end-to-end solutions with a focus on quality, sustainability, and client satisfaction.",
    image: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
    points: [
      {
        title: "Expert Design Team",
        description: "Our team of certified designers brings years of experience to every project.",
        color: "#FF6B35"
      },
      {
        title: "Quality Materials",
        description: "We use only premium, sustainable materials from trusted suppliers.",
        color: "#008C9E"
      },
      {
        title: "On-Time Delivery",
        description: "Strict project timelines with regular progress updates.",
        color: "#1D3557"
      },
      {
        title: "Post-Service Support",
        description: "Comprehensive warranty and ongoing support after project completion.",
        color: "#695424ff"
      }
    ]
  },

  // FAQ Data
  faqs: [
    {
      id: 1,
      question: "What's included in your design service package?",
      answer: "Our packages include initial consultation, space planning, 3D visualizations, material selection, furniture recommendations, project management, and final styling. We provide detailed breakdowns for each service.",
      icon: <DesignServicesIcon sx={{ color: "#FF6B35" }} />
    },
    {
      id: 2,
      question: "How long does a typical service take to complete?",
      answer: "Timelines vary: Consultation (1-2 days), Planning (1-2 weeks), Execution (varies by scope). We provide detailed timelines during our initial meeting.",
      icon: <ScheduleIcon sx={{ color: "#008C9E" }} />
    },
    {
      id: 3,
      question: "Do you provide material samples?",
      answer: "Yes, we provide physical samples of all major materials including fabrics, finishes, flooring, and paint colors for your approval before purchase.",
      icon: <CheckCircleIcon sx={{ color: "#1D3557" }} />
    },
    {
      id: 4,
      question: "Can I make changes during the project?",
      answer: "Yes, we accommodate changes during the planning phase. Once execution begins, changes may affect timeline and cost, which we'll discuss transparently.",
      icon: <VerifiedUserIcon sx={{ color: "#695424ff" }} />
    },
    {
      id: 5,
      question: "Do you work with my budget?",
      answer: "Absolutely. We're transparent about costs and work within your budget, suggesting alternatives when needed to achieve your vision cost-effectively.",
      icon: <LocalOfferIcon sx={{ color: "#FF6B35" }} />
    },
    {
      id: 6,
      question: "What areas do you serve?",
      answer: "We serve the entire metropolitan area and surrounding regions. Virtual consultations available for out-of-area clients.",
      icon: <LocationOnIcon sx={{ color: "#008C9E" }} />
    },
    {
      id: 7,
      question: "Do you handle permits and approvals?",
      answer: "Yes, we manage all necessary permits and approvals for renovation projects, ensuring compliance with local regulations.",
      icon: <VerifiedUserIcon sx={{ color: "#1D3557" }} />
    },
    {
      id: 8,
      question: "What happens after project completion?",
      answer: "We provide a warranty on our work and materials, plus follow-up support for any adjustments needed. Your satisfaction is our priority.",
      icon: <ThumbUpIcon sx={{ color: "#695424ff" }} />
    }
  ],

  // Related Projects
  serviceProjects: [
    {
      id: 1,
      title: "Modern Urban Apartment",
      category: "Residential",
      image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      description: "Complete renovation of a 2BHK apartment with modern minimalist design",
      location: "Downtown",
      duration: "8 Weeks",
      services: ["Full Home Design", "Kitchen Renovation"]
    },
    {
      id: 2,
      title: "Tech Startup Office",
      category: "Commercial",
      image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      description: "Collaborative workspace design for a growing tech company",
      location: "Business District",
      duration: "12 Weeks",
      services: ["Office Design", "Lighting Design"]
    },
    {
      id: 3,
      title: "Luxury Kitchen Makeover",
      category: "Renovation",
      image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      description: "Complete kitchen transformation with premium appliances and finishes",
      location: "Suburban Home",
      duration: "6 Weeks",
      services: ["Kitchen Renovation"]
    }
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Robert Chen",
      role: "Homeowner",
      rating: 5,
      comment: "The full home design service transformed our living space beyond expectations.",
      service: "Full Home Design"
    },
    {
      id: 2,
      name: "Lisa Park",
      role: "Restaurant Owner",
      rating: 5,
      comment: "Professional and efficient kitchen renovation service. Highly recommended!",
      service: "Kitchen Renovation"
    },
    {
      id: 3,
      name: "David Miller",
      role: "CEO",
      rating: 5,
      comment: "Our new office design has boosted employee productivity by 30%.",
      service: "Office Design"
    }
  ],

  // CTA Data
  cta: {
    title: "Ready to Start Your Project?",
    subtitle: "Get a personalized quote for your interior design needs. No obligation, just expert advice.",
    phone: "+91 83708 25457"
  },

  // UI State
  loading: false,
  error: null,
  activeTab: 0,
  activeFilter: "all",
  expandedFaqs: []
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    // Set active service tab
    setActiveServiceTab: (state, action) => {
      state.activeTab = action.payload;
    },

    // Set active filter
    setActiveServiceFilter: (state, action) => {
      state.activeFilter = action.payload;
    },

    // Toggle FAQ expansion
    toggleServiceFaq: (state, action) => {
      const faqId = action.payload;
      const index = state.expandedFaqs.indexOf(faqId);
      if (index > -1) {
        state.expandedFaqs.splice(index, 1);
      } else {
        state.expandedFaqs.push(faqId);
      }
    },

    // Expand all FAQs
    expandAllServiceFaqs: (state) => {
      state.expandedFaqs = state.faqs.map(faq => faq.id);
    },

    // Collapse all FAQs
    collapseAllServiceFaqs: (state) => {
      state.expandedFaqs = [];
    },

    // Update hero data
    updateServiceHero: (state, action) => {
      state.hero = { ...state.hero, ...action.payload };
    },

    // Update categories
    updateServiceCategories: (state, action) => {
      state.categories = action.payload;
    },

    // Update all services
    updateAllServices: (state, action) => {
      state.allServices = action.payload;
    },

    // Update popular services
    updatePopularServices: (state, action) => {
      state.popularServices = action.payload;
    },

    // Update service process
    updateServiceProcess: (state, action) => {
      state.serviceProcess = action.payload;
    },

    // Update benefits
    updateServiceBenefits: (state, action) => {
      state.serviceBenefits = action.payload;
    },

    // Update FAQs
    updateServiceFaqs: (state, action) => {
      state.faqs = action.payload;
    },

    // Update related projects
    updateServiceProjects: (state, action) => {
      state.serviceProjects = action.payload;
    },

    // Update testimonials
    updateServiceTestimonials: (state, action) => {
      state.testimonials = action.payload;
    },

    // Update CTA
    updateServiceCta: (state, action) => {
      state.cta = { ...state.cta, ...action.payload };
    },

    // Set loading state
    setServiceLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setServiceError: (state, action) => {
      state.error = action.payload;
    },

    // Clear error
    clearServiceError: (state) => {
      state.error = null;
    },

    // Reset to initial state
    resetServiceData: (state) => {
      return initialState;
    }
  }
});

export const {
  setActiveServiceTab,
  setActiveServiceFilter,
  toggleServiceFaq,
  expandAllServiceFaqs,
  collapseAllServiceFaqs,
  updateServiceHero,
  updateServiceCategories,
  updateAllServices,
  updatePopularServices,
  updateServiceProcess,
  updateServiceBenefits,
  updateServiceFaqs,
  updateServiceProjects,
  updateServiceTestimonials,
  updateServiceCta,
  setServiceLoading,
  setServiceError,
  clearServiceError,
  resetServiceData
} = servicesSlice.actions;

export default servicesSlice.reducer;